import { AvailabilityAndPricingService } from "../../services/AvailabilityAndPricingService";
import { useApi } from "./useApi";
import { useConfiguration } from "./useConfiguration";

export const useAvailabilityAndPricingApi = () => {
    const { executeApiOperation } = useApi();
    const { appConfig } = useConfiguration();

    const availabilityAndPricingService = new AvailabilityAndPricingService(appConfig.apiBaseUrl);

    const getDailyPrices = async (propertyId, roomId, from, to) => {
        return executeApiOperation(() => availabilityAndPricingService.getDailyPrices(propertyId, roomId, from, to));
    };

    const getDailyAvailability = async (propertyId, roomId, from, to) => {
        return executeApiOperation(() => availabilityAndPricingService.getDailyAvailability(propertyId, roomId, from, to));
    };

    const getDailyAvailabilityAndPrices = async (propertyId, roomId, from, to) => {
        return executeApiOperation(() => availabilityAndPricingService.getDailyAvailabilityAndPrices(propertyId, roomId, from, to));
    };

    const getLatestCheckoutDate = async (propertyId, roomId, checkin, ignoreReservationId) => {
        return executeApiOperation(() => availabilityAndPricingService.getLatestCheckoutDate(propertyId, roomId, checkin, ignoreReservationId));
    };

    const getTotalPrice = async (propertyId, roomId, planId, checkin, checkout, adults) => {
        return executeApiOperation(() => availabilityAndPricingService.getTotalPrice(propertyId, roomId, planId, checkin, checkout, adults));
    };

    const getCheckinAvailability = async (propertyId, from, to) => {
        return executeApiOperation(() => availabilityAndPricingService.getCheckinAvailability(propertyId, from, to));
    };

    const getCheckoutAvailability = async (propertyId, checkin) => {
        return executeApiOperation(() => availabilityAndPricingService.getCheckoutAvailability(propertyId, checkin));
    };

    return {
        getDailyPrices,
        getDailyAvailability,
        getDailyAvailabilityAndPrices,
        getLatestCheckoutDate,
        getTotalPrice,
        getCheckinAvailability,
        getCheckoutAvailability,
    };
};
